import Vue from "vue";
import config from "@/assets/js/config.js";

/**
 * 时间格式转换
 * @param time Date/Number
 * @param fmt string , 转换格式
 * demo ->  {{time | dateFormat('yyyy-MM-dd hh:mm:ss')}}
 */
Vue.filter("dateFormat", function(value, fmt) {
  if (!(value instanceof Date)) {
    value = new Date(value);
  }
  let o = {
    "M+": value.getMonth() + 1, //月份
    "d+": value.getDate(), //日
    "h+": value.getHours(), //小时
    "m+": value.getMinutes(), //分
    "s+": value.getSeconds(), //秒
    "q+": Math.floor((value.getMonth() + 3) / 3), //季度
    S: value.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (value.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
});

/**
 * 格式转换
 * @param value Number
 * @param initUnit String , 单位
 * demo -> {{ 1024 |  fileSizeFormat('KB')}} -> 1MB
 */
Vue.filter("fileSizeFormat", function(value, initUnit) {
  if (!value) {
    return "0 Bytes";
  }
  let unitArr = new Array(
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB",
    "EB",
    "ZB",
    "YB"
  );
  let initIndex;
  if (initUnit) {
    initIndex = unitArr.indexOf(initUnit);
    initIndex = initIndex >= 0 ? initIndex : 0;
  }
  let srcsize = parseFloat(value);
  let index = Math.floor(Math.log(srcsize) / Math.log(1024));
  let size = srcsize / Math.pow(1024, index);

  var re = /^\d+$/;
  if (!re.test(size)) {
    size = size.toFixed(2);
  }

  return size + unitArr[index + initIndex];
});

/**
 * 固定文本内容
 * @param value string/number/boolean , 数值
 * @param key string , 键值
 * demo ->  {{1 | lang('useState')}} -> 开启
 */
Vue.filter("lang", function(value, key) {
  return config[key][value] || "";
});



// WEBPACK FOOTER //
// ./src/utils/filter.js